const translations = {
  "en": {
    "Add Trade": "Add Trade",
    "Are you sure you want to delete this transaction?": "Are you sure you want to delete this transaction?",
    "Delete Transaction": "Delete Transaction",
    "Transactions Details": "Transactions Details"
  },
  "zh-tw": {
    "Add Trade": "新增交易",
    "Are you sure you want to delete this transaction?": "你確定要刪除這筆交易嗎？",
    "Delete Transaction": "刪除交易",
    "Transactions Details": "交易詳情"
  }
};

export default translations;
